import React from "react";
import "./newAndBetterConcept.scss";

//Imagens:
import ImgNewAndBetterConcept from "../../../../assets/telecom/telecom.png";
import { useTranslation } from "react-i18next";
import SectionComponent from "../../../../components/utils/SectionComponent";

function NewAndBetterConcept() {
  const { t } = useTranslation()

  return (
    <div className="container-new-and-better-concept">
      <div className="img-new-and-better-concept">
        <img src={ImgNewAndBetterConcept} alt="" />
      </div>
      <div className="texts-new-and-better-concept">
        <SectionComponent title={t("telecom.title")} text={t("telecom.section_text_1")}>
          <p>{t("telecom.section_text_2")}</p>
        </SectionComponent>
        <a href="/form">
          <button id="btn-new-and-better-concept">
            {t("buttons.demo_btn_alternative_text_1")}
          </button>
        </a>
      </div>
    </div>
  );
}

export default NewAndBetterConcept;
